import { create } from "zustand";
import { ProjectRecord } from "@/types";

interface GlobalSizingToolState {
  isOpen: boolean;
  projectData: ProjectRecord | null;
  forceManualMode: boolean;
  isDemo: boolean;
}

interface GlobalSizingToolActions {
  openModal: (
    projectData?: ProjectRecord,
    forceManualMode?: boolean,
    isDemo?: boolean
  ) => void;
  closeModal: () => void;
}

export const useGlobalSizingToolStore = create<
  GlobalSizingToolState & GlobalSizingToolActions
>((set) => ({
  isOpen: false,
  projectData: null,
  forceManualMode: false,
  isDemo: false,
  openModal: (
    projectData?: ProjectRecord | null,
    forceManualMode: boolean = false,
    isDemo: boolean = false
  ) => {
    set({
      isOpen: true,
      projectData: projectData || null,
      forceManualMode,
      isDemo,
    });
  },
  closeModal: () => {
    set({
      isOpen: false,
      projectData: null,
      forceManualMode: false,
      isDemo: false,
    });
  },
}));
